export const generateIdentifier = ({
  airportCode = '',
  loungeId = '',
  pathname,
}) => {
  if (pathname?.includes('culinary-collective')) return 'culinary collective';
  if (pathname?.includes('centurion-network')) return 'centurion landing';
  if (pathname?.includes('terms')) return 'Terms and Conditions';
  if (pathname?.includes('all-airports')) return 'all airports page';
  if (loungeId) return 'lounge details page';
  if (airportCode) return 'airport page';
  return 'home page';
};
/**
 * This function generates custom event info
 * @param {{ type: string, target: { id: string }}} eventData - event data
 * @param {{ identifier: string, element: string, detail: string }} additionalInfo - additional info
 * @param {{ info: string, products: Array.<{type: string, description: string, locale: string}>}} metaInfo - meta info
 */

export const generateCustomEventInfo = (
  eventData,
  additionalInfo,
  metaInfo
) => {
  return {
    identifier: additionalInfo.identifier,
    type: eventData.type,
    element: additionalInfo.element || eventData.target.id,
    detail: additionalInfo.detail,
    timestamp: new Date().toISOString(),
    meta: {
      info: metaInfo.info || '',
      products: metaInfo.products || [],
    },
  };
};
